/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PaxCheckDocumentRequirement, PaxCheckDocumentRequirementFromJSONTyped, PaxCheckDocumentRequirementToJSON } from "./PaxCheckDocumentRequirement";
import { PaxCheckInfoItem, PaxCheckInfoItemFromJSONTyped, PaxCheckInfoItemToJSON } from "./PaxCheckInfoItem";


/**
 * @type PaxCheckChecklistItem
 * 
 * @export
 */
export type PaxCheckChecklistItem = { type: 'document-requirement' } & PaxCheckDocumentRequirement | { type: 'info-item' } & PaxCheckInfoItem;

export function PaxCheckChecklistItemFromJSON(json: any): PaxCheckChecklistItem {
    return PaxCheckChecklistItemFromJSONTyped(json, false);
}

export function PaxCheckChecklistItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckChecklistItem {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'document-requirement':
            return Object.assign({}, PaxCheckDocumentRequirementFromJSONTyped(json, true), { type: 'document-requirement' } as const);
        case 'info-item':
            return Object.assign({}, PaxCheckInfoItemFromJSONTyped(json, true), { type: 'info-item' } as const);
        default:
            return json;
    }
}

export function PaxCheckChecklistItemToJSON(json: any): any {
    return PaxCheckChecklistItemToJSONTyped(json, false);
}

export function PaxCheckChecklistItemToJSONTyped(value?: PaxCheckChecklistItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'document-requirement':
            return Object.assign({}, PaxCheckDocumentRequirementToJSON(value), { type: 'document-requirement' } as const);
        case 'info-item':
            return Object.assign({}, PaxCheckInfoItemToJSON(value), { type: 'info-item' } as const);
        default:
            return value;
    }
}

